/*  Candidate Routes */
export default [
  {
    path: '/jobs/apply/',
    name: 'apply-offer',
    props: true,
    meta: {
      name: 'main.routes.apply-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/user/OfferApply.vue')
  },
  {
    path: '/jobs/applied/',
    name: 'applied-offers',
    props: true,
    meta: {
      name: 'main.routes.applied-offers',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/user/AppliedOffers.vue')
  },
  {
    path: '/jobs/cv',
    name: 'my-cv',
    meta: {
      name: 'main.routes.my-cv',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/user/UserCV.vue')
  },
]
